import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Text } from 'shared/components';
import { truncate } from 'lodash';
import {
  PieChart as PieChartRE,
  Pie,
  Sector,
  Cell,
  ResponsiveContainer
} from 'recharts';
import numeral from 'numeral';
import { TextContainer, ChartContainer } from './styles';


const PieChart = ({ title, total, nonGuess, height = '120px' }) => {
  const { custom: { positive, negative, neutral, inactive }} = useTheme();
  const percentage = (nonGuess / total) * 100;
  const color = (percentage >= 55) ? positive : (percentage < 55 && percentage >= 45) ? neutral : negative;

  const data = [
    {
      name: title,
      value: percentage,
      color
    },
    {
      name: 'Guess',
      value: parseFloat((100 - percentage).toFixed(2)),
      color: inactive
    }
  ];

  const renderActiveShape = props => {
    const { cx, cy, innerRadius, outerRadius, fill, percent } = props;
    const textAnchor = 'end';

    return (
      <g>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={90}
          endAngle={-360}
          fill={fill}
        />
        <text
          x={116}
          y={42}
          dy={18}
          textAnchor={textAnchor}
          fill="#000000"
          style={{ fontSize: 14 }}
        >
          {`${numeral(percentage).format('0')}%`}
        </text>
      </g>
    );
  };

  return (
    <ChartContainer style={{ height }}>
      <ResponsiveContainer height="100%" width="100%">
        <PieChartRE>
          <Pie
            activeIndex={0}
            activeShape={renderActiveShape}
            data={data}
            cx={95}
            cy={50}
            innerRadius={30}
            outerRadius={45}
            startAngle={90}
            endAngle={-360}
            fill="#8884d8"
            dataKey="value"
            nameKey="name"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
        </PieChartRE>
      </ResponsiveContainer>
      {title && (
        <TextContainer>
          <Tooltip title={title} arrow>
            <Box
              style={{ cursor: 'pointer', margin: 0 }}
              component="div"
              my={2}
              textOverflow="ellipsis"
              overflow="hidden"
            >
              {truncate(title, { length: 18 })}
            </Box>
          </Tooltip>
        </TextContainer>
      )}
      {title && (
        <Text variant="body2" style={{textAlign: 'center'}}>
          {`${nonGuess} Non Guess out of ${total} total`}
        </Text>
      )}
    </ChartContainer>
  );
};

export default React.memo(PieChart);
